import { render, staticRenderFns } from "./CollapsingTopMenu.vue?vue&type=template&id=d455d362&scoped=true"
import script from "./CollapsingTopMenu.vue?vue&type=script&lang=js"
export * from "./CollapsingTopMenu.vue?vue&type=script&lang=js"
import style0 from "./CollapsingTopMenu.vue?vue&type=style&index=0&id=d455d362&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d455d362",
  null
  
)

export default component.exports